import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import {
  fetchIndexHealthSampleFailure,
  fetchIndexHealthSampleRequest,
  fetchIndexHealthSampleSuccess,
  saveSOWUsersAndImportFailure,
  saveSOWUsersAndImportRequest,
  saveSOWUsersAndImportSuccess,
} from 'actions/customers';
import { API, ErrorObject } from 'types';

export type CustomersState = {
  indexHealthSample: API.Customers.IndexHealthSample | null;
  loading: string[];
  error: ErrorObject | null;
};

export const defaultState: CustomersState = {
  indexHealthSample: null,
  loading: [],
  error: null,
};

type CustomersReducer<P = void> = (
  state: CustomersState,
  payload: PayloadAction<P>
) => CustomersState;

const handleFetchIndexHealthSampleRequest: CustomersReducer<void> = (state) => {
  state.loading = [...state.loading, fetchIndexHealthSampleRequest.toString()];
  return state;
};
const handleFetchIndexHealthSampleSuccess: CustomersReducer<API.Customers.IndexHealthSample> = (
  state,
  { payload }
) => {
  state.indexHealthSample = payload;
  state.loading = state.loading.filter((s) => s !== fetchIndexHealthSampleRequest.toString());
  return state;
};
const handleFetchIndexHealthSampleFailure: CustomersReducer<ErrorObject> = (state, { payload }) => {
  state.error = payload;
  state.loading = state.loading.filter((s) => s !== fetchIndexHealthSampleRequest.toString());
  return state;
};

const handleSaveSOWUsersAndImportRequest: CustomersReducer = (state) => {
  state.loading = [...state.loading, saveSOWUsersAndImportRequest.toString()];
  return state;
};
const handleSaveSOWUsersAndImportSuccess: CustomersReducer = (state) => {
  state.loading = state.loading.filter((s) => s !== saveSOWUsersAndImportRequest.toString());
  return state;
};
const handleSaveSOWUsersAndImportFailure: CustomersReducer<ErrorObject> = (state, { payload }) => {
  state.error = payload;
  state.loading = state.loading.filter((s) => s !== saveSOWUsersAndImportRequest.toString());
  return state;
};

const handlers = {
  [fetchIndexHealthSampleRequest.toString()]: handleFetchIndexHealthSampleRequest,
  [fetchIndexHealthSampleSuccess.toString()]: handleFetchIndexHealthSampleSuccess,
  [fetchIndexHealthSampleFailure.toString()]: handleFetchIndexHealthSampleFailure,

  [saveSOWUsersAndImportRequest.toString()]: handleSaveSOWUsersAndImportRequest,
  [saveSOWUsersAndImportSuccess.toString()]: handleSaveSOWUsersAndImportSuccess,
  [saveSOWUsersAndImportFailure.toString()]: handleSaveSOWUsersAndImportFailure,
};

const customersReducer = createReducer(defaultState, handlers);

export default customersReducer;
